export default "__VITE_ASSET__DghnRRu0__"